import {useRouter} from 'next/router';
import {useMemo} from 'react';

import {
  ORDER_BY_FILTER,
  ORDER_FILTER,
  SEARCH_FILTERS,
} from '@/src/app/constants/search';
import FilterRow from '@/src/Search/components/FilterRow';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {RadioButtonCommon, SimpleCollapse, Text} from '@/src/ui';

const VacanciesSortingFilter = () => {
  const {query} = useRouter();
  const {setQueryFilters} = useSearchFilters();

  const SORTING_METHODS = useMemo(
    () => [
      {
        id: '1',
        isActive:
          (query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
            query[SEARCH_FILTERS.ORDER_BY] ===
              ORDER_BY_FILTER.VACANCY_PUBLISH) ||
          (query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
            !query[SEARCH_FILTERS.ORDER_BY]) ||
          (query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
            query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.APPROVED_AT),
        label: 'search.sortingAsc',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.VACANCY_PUBLISH,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
      {
        id: '2',
        isActive:
          query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.ASC &&
          query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.VACANCY_PUBLISH,
        label: 'search.sortingDesc',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.ASC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.VACANCY_PUBLISH,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
      {
        id: '5',
        isActive:
          query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.ASC &&
          query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.SALARY,
        label: 'search.salary-asc',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.ASC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.SALARY,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
      {
        id: '6',
        isActive:
          query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
          query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.SALARY,
        label: 'search.salary-desc',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.SALARY,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
      {
        id: '7',
        isActive:
          query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.ASC &&
          query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.ENTRY_DATE,
        label: 'search.entry-date-asc',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.ASC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.ENTRY_DATE,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
      {
        id: '8',
        isActive:
          query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
          query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.ENTRY_DATE,
        label: 'search.entry-date-desc',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.ENTRY_DATE,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
      {
        id: '3',
        isActive:
          query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.ASC &&
          query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.VACANCY_EXPIRED,
        label: 'search.expiredSoon',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.ASC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.VACANCY_EXPIRED,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
      {
        id: '4',
        isActive:
          query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
          query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.VACANCY_EXPIRED,
        label: 'search.expiredNotSoon',
        paramsToApply: {
          [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
          [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.VACANCY_EXPIRED,
          [SEARCH_FILTERS.OFFSET]: query[SEARCH_FILTERS.OFFSET] || '0',
        },
      },
    ],
    [query]
  );

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.sorting'} />
        </Text>
      }
    >
      {SORTING_METHODS.map((sort) => (
        <FilterRow key={sort.id}>
          <RadioButtonCommon
            id={sort.id}
            type="radio"
            name="sorting"
            label={<TextLocal id={sort.label} />}
            checked={sort.isActive}
            onChange={() =>
              setQueryFilters({
                ...sort.paramsToApply,
              })
            }
            isSemibold={undefined}
            error={undefined}
          />
        </FilterRow>
      ))}
    </SimpleCollapse>
  );
};

export default VacanciesSortingFilter;
